export const intersects = (arrayA: any[], arrayB: any[]) =>
	arrayA.some((item) => arrayB.includes(item))

export const isJSON = (value: string) => {
	try {
		JSON.parse(value)
		return true
	} catch (error) {
		return false
	}
}

export function arraysAreEqual(arr1: unknown, arr2: unknown) {
	if (!Array.isArray(arr1) || !Array.isArray(arr2)) return false
	if (arr1.length !== arr2.length) return false
  
	for (let i = 0; i < arr1.length; i++) {
		if (arr1[i] !== arr2[i]) return false
	}
  
	return true
}

export const éCargoAdminDeLoja = (cargo: string = '', secretarioDeInformatica = false) => {
	if(secretarioDeInformatica) return true
	return [
		'VENERAVEL MESTRE',
		'SECRETARIO',
	].includes(cargo)
}

export function containsAny(str: string, terms: string[]) {
  const pattern = new RegExp(terms.join("|"), "i");
  return pattern.test(str);
}
